import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=a163e704&"
import script from "./adminLayout.vue?vue&type=script&lang=ts&"
export * from "./adminLayout.vue?vue&type=script&lang=ts&"
import style0 from "./adminLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports